// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppWrapped from './AppWrapped';
import reportWebVitals from './reportWebVitals';

// IMPORTANT: initialize thedatchain/SPNDAT Firebase app once here
import './firebase'; // <-- this should export initializeApp(...)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppWrapped />
  </React.StrictMode>
);

reportWebVitals();
